define('../app/fukit/model/user.model',['require','exports','module','./admin.base.model'],function(require, exports, module) {
  var AdminBaseModel = require('./admin.base.model');

  var UserModel = AdminBaseModel.extend({
    radioRequests: {
      'models UserModel': '@constructor',
      'models User': '@constructor',
    },

    urlRoot: AdminBaseModel.prototype.baseUrlRoot + '/user/user',
  });

  UserModel.GroupsByUserCollection = UserModel.Collection.extend({
    url: UserModel.urlTemplate(UserModel.prototype.baseUrlRoot + '/user/user/:userId/group'),
  });

  module.exports = UserModel;
});

